import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';
import { captureEvent } from '../utils/posthog';
import { EVENTS, PROPERTIES } from '../utils/analytics';

export const FAQ = () => {
  const handleFAQExpand = (faqId, question) => {
    captureEvent(EVENTS.FAQ_EXPANDED, {
      [PROPERTIES.FAQ_ID]: faqId,
      [PROPERTIES.FAQ_QUESTION]: question,
    });
  };
  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-black to-gray-950 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Everything you need to know about Snapcom. Can't find the answer you're looking for? Reach out to our support team.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion 
            type="single" 
            collapsible 
            className="space-y-4"
            onValueChange={(value) => {
              if (value) {
                const faqId = value.replace('item-', '');
                const faq = faqs.find(f => f.id.toString() === faqId);
                if (faq) {
                  handleFAQExpand(faq.id, faq.question);
                }
              }
            }}
          >
            {faqs.map((faq, index) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className={`glass rounded-2xl px-6 border-none animate-fade-in-up stagger-${Math.min(index + 1, 6)}`}
              >
                <AccordionTrigger className="text-left text-white hover:text-yellow-500 transition-colors duration-200 text-lg font-semibold py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional help section */}
        <div className="mt-16 text-center glass rounded-2xl p-8 max-w-2xl mx-auto animate-fade-in-up stagger-6">
          <h3 className="text-2xl font-bold text-white mb-3">Still have questions?</h3>
          <p className="text-gray-400 mb-6">
            Our support team is here to help you get started and make the most of Snapcom.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:support@snapcom.com"
              className="inline-flex items-center justify-center px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-lg transition-all duration-300"
            >
              Email Support
            </a>
            <a
              href="#waitlist"
              className="inline-flex items-center justify-center px-6 py-3 border border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-semibold rounded-lg transition-all duration-300"
            >
              Schedule a Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};